"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Filter = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Filter = require("./Filter.styles");
var _Input = require("../../../Input");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Filter = props => {
  const {
    value,
    placeholder,
    onUpdateValue,
    isFocused = false
  } = props;
  const styles = (0, _Filter.useStyles)(props);
  const inputRef = (0, _react.useRef)(null);
  const handleClear = () => {
    onUpdateValue('');
  };
  const handleChange = val => {
    onUpdateValue(val);
  };
  (0, _react.useEffect)(() => {
    if (isFocused) {
      setTimeout(() => {
        inputRef.current?.focus();
      }, 10);
    }
  }, [isFocused]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: styles['cc-Select__filter'],
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: styles['cc-Select__filter-content'],
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Input.Input, {
        type: "text",
        view: "none",
        size: "small",
        placeholder: placeholder,
        value: value,
        onChange: handleChange,
        isWithClearButton: Boolean(value && value.length > 0),
        onClearButtonClick: handleClear,
        id: "ccSelectFilter",
        ref: inputRef
      })
    })
  });
};
exports.Filter = Filter;